import * as api from '../api/index'

import { ADD_NEW_METAL, UPDATE_METAL, DELETE_METAL, FETCH_METALS_BY_USER, FETCH_METAL, START_LOADING, END_LOADING, ALL_METALS } from './constants'


export const getMetal = (id) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchMetal(id);
      dispatch({ type: FETCH_METAL, payload: { metal: data } });

    } catch (error) {
      console.log(error);
    }
  };


export const getMetalsByUser =(searchQuery) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING })
      const  { data } = await api.fetchMetalsByUser(searchQuery)
      dispatch({ type: FETCH_METALS_BY_USER, payload: data.results });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)      
    }
  }

  export const getAllMetals =() => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING })
      const  { data } = await api.fetchMetals()
      dispatch({ type: ALL_METALS, payload: data.results });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)      
    }
  }


export const createMetal =(metal, openSnackbar) => async (dispatch) => {

    try {
        const { data } = await api.addMetal(metal)
        dispatch({ type: ADD_NEW_METAL, payload: data.data })
        openSnackbar("Metal added successfully")

    } catch (error) {
        console.log(error)
    }
}


export const updateMetal =(id, metal, openSnackbar) => async (dispatch) => {

    const { data } = await api.updateMetal(id, metal)
      dispatch({ type: UPDATE_METAL, payload: data.data })
    openSnackbar("Metal updated successfully")
    try {
        
    } catch (error) {
        console.log(error)
    }
}
 
export const deleteMetal =(id, openSnackbar) => async (dispatch) => {
    try {
        await api.deleteMetal(id)

        dispatch({type: DELETE_METAL, payload: id})
        openSnackbar("Metal deleted successfully")
    } catch (error) {
        console.log(error)
    }
}